import { combineReducers } from 'redux'
import generalReducer from './GeneralReducer'
import organizationReducer from './OrganizationReducer'

export default combineReducers({
  general: generalReducer,
  organization: organizationReducer
})